var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Modal',{ref:"modal",attrs:{"title":_vm.store.title,"ok-title":_vm.store.okLabel,"cancel-title":_vm.store.cancelLabel,"hide-x-btn":true},on:{"ok":_vm.onOk,"cancel":_vm.onCancel}},[_vm._v(" "+_vm._s(_vm.store.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }